import React from "react";

import Content from "./Content";
import styles from "./ContentGroup.module.scss";

interface Props {
  indexCache?: number[];
}

class ContentGroup extends React.PureComponent<Props> {
  public render() {
    const { children, indexCache = [] } = this.props;

    const activeIndex = indexCache[indexCache.length - 1];

    return (
      <div className={styles.contents}>
        {React.Children.map(
          children,
          (child, index) =>
            indexCache.indexOf(index) !== -1 &&
            React.isValidElement<Content["props"]>(child) &&
            React.cloneElement(child, {
              isActive: index === activeIndex,
            }),
        )}
      </div>
    );
  }
}

export default ContentGroup;
